import { SharedModule } from '../../../shared/shared.module';
import { DocumentsMecenatComponent } from './document_mecenat.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [NgbModule, SharedModule, BsDatepickerModule, DataTableModule],
  declarations: [DocumentsMecenatComponent],
  exports: [DocumentsMecenatComponent]
})
export class DocumentsMecenatModule {}
